export default {
  setToken(state, token) {
    state.token = token;
  },
  clearToken(state) {
    state.token = null;
  },
  setSummary(state, summary) {
    state.summary = summary;
  },
  setSummaryLoading(state, loading) {
    state.summaryLoading = loading;
  },
  setStates(state, states) {
    state.states = states;
  },
  setStatesLoading(state, loading) {
    state.statesLoading = loading;
  },
  setCities(state, cities) {
    state.cities = cities;
  },
  setCitiesLoading(state, loading) {
    state.citiesLoading = loading;
  },
  setCurrentState(state, data) {
    state.currentState = data;
  },
  setCurrentStateLoading(state, loading) {
    state.currentStateLoading = loading;
  },
  setCurrentSchool(state, data) {
    state.currentSchool = data;
  },
  setCurrentSchoolLoading(state, loading) {
    state.currentSchoolLoading = loading;
  },
  setSchools(state, schools) {
    state.schools = schools;
  },
  clearSchools(state) {
    state.schools = [];
    state.schoolsTotal = 0;
  },
  setSchoolsTotal(state, total) {
    state.schoolsTotal = total;
  },
  setSchoolsLoading(state, loading) {
    state.schoolsLoading = loading;
  },
  setStudents(state, students) {
    state.students = students;
  },
  setStudentsTotal(state, total) {
    state.studentsTotal = total;
  },
  setStudentsLoading(state, loading) {
    state.studentsLoading = loading;
  },
  setSports(state, sports) {
    state.sports = sports;
  },
  setSportsLoading(state, loading) {
    state.sportsLoading = loading;
  },
  setTeams(state, teams) {
    state.teams = teams;
  },
  setTeamsLoading(state, loading) {
    state.teamsLoading = loading;
  },
  clearStudents(state) {
    state.students = [];
    state.studentsTotal = 0;
    state.teams = [];
  },
  setStudentFilter(state, filter) {
    state.studentFilter = filter;
  },
};
